// import axios from "axios";
import request from "../../assets/js/Request.js";
// 获取用户个人信息
export const getUserInfo = (params) => {
    return request.post(`getUserInfo`,params);
  };
// 更新用户个人信息
export const updateUserInfo = (params) => {
  return request.post(`user/update`,params);
};
// 获取用户信息
export const getBmInfo = (params) => {
  return request.get(`user/info`);
};
// 提交审核
export const setBaoming = (params) => {
  return request.post(`registration/submit`,params);
};
// 获取培训列表 
export const gettrainings = (params) => {
  return request.get(`trainings?page=${params.page}&limit=${params.limit}`);
};
// 获取参赛作品
export const getEntryInformation = (params) => {
  return request.post(`getEntryInformation`,params);
};
// 获取职业类型/培训类型字典 job_type=职业类型、training_type=培训类型
export const getDictionaries = (params) => {
  return request.get(`dictionaries?group=${params}`);
};
// 获取职称列表 id:1=医生,2=护士,3=技师
export const getTitles = (params) => {
  return request.get(`titles?jobType=${params}`);
};
// 获取科室列表 状态:1=显示，2=隐藏，3=仅评委可用
export const getDpartments= (params) => {
  return request.get(`departments?status=${params}`);
};
// 报名状态查询
export const getRegistrationInfo = (params) => {
  return request.get(`registration/info`);
};